// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50240c2f","455":"672f4eb4","488":"9ea6021d","977":"949749b2"}[chunkId] + ".chunk.js";
};